import { useMixpanel } from "@/contexts/mixpanelContext";
import { useEffect } from "react";

interface UseMixpanelPageViewOptions {
  pageName: string;
  options?: any;
}

const useMixpanelPageView = ({
  pageName,
  options,
}: UseMixpanelPageViewOptions) => {
  const { handlePageView } = useMixpanel();

  useEffect(() => {
    handlePageView(pageName, options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handlePageView, pageName]);
};

export default useMixpanelPageView;
